import type { DbPortalSkalaEintrag } from '@gql/shared-types';

/**
 * Sichtbarkeit der Skala (Entscheidung Moritz 08.10.2026: im Betrieb nur bewertete Gebiete):
 *   bewertet – nur abschließend bewertete Werte, vorläufige erscheinen als „offen“ (Standard, auch bei fehlender Angabe)
 *   alle     – bewertete und vorläufige Werte anzeigen (Entwicklung: apps/db-portal/.env.development)
 *   aus      – keine Skala anzeigen
 */
export type SkalaModus = 'alle' | 'bewertet' | 'aus';

export function skalaModusAusEnv(wert: string | undefined): SkalaModus {
  return wert === 'alle' || wert === 'aus' ? wert : 'bewertet';
}

export const SKALA_MODUS: SkalaModus = skalaModusAusEnv(import.meta.env?.['VITE_SKALA_MODUS'] as string | undefined);

const OFFEN: DbPortalSkalaEintrag = {
  wert: null,
  wert_herkunft: null,
  status: 'offen',
  referenz: false,
  begruendung: null,
  quelle: null,
  merkmale: null,
  aktualisiert_am: null,
};

/** Liefert den anzuzeigenden Eintrag oder null, wenn die Skala ausgeblendet ist. */
export function sichtbareSkala(
  eintrag: DbPortalSkalaEintrag | undefined,
  modus: SkalaModus = SKALA_MODUS,
): DbPortalSkalaEintrag | null {
  if (modus === 'aus') return null;
  if (!eintrag) return OFFEN;
  if (modus === 'bewertet' && eintrag.status === 'vorläufig') return OFFEN;
  return eintrag;
}

export const MERKMAL_TEXT: Record<string, { zeichen: string; text: string }> = {
  gleich: { zeichen: '✓', text: 'wie Berlin' },
  abweichend: { zeichen: '≠', text: 'abweichend' },
  offen: { zeichen: '?', text: 'noch offen' },
  entfällt: { zeichen: '–', text: 'nicht maßgeblich' },
};
